import $ from 'jquery';
import 'slick-carousel';

const Slider = () => {
  const carousel = $('.slider');

  carousel.on(
    'init reInit afterChange',
    function (event, slick, currentSlide, nextSlide) {
      // currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
      const container = this.parentElement;
      const pagingInfo = container.querySelector('.pagingInfo');
      const i = (currentSlide || 0) + 1;
      $(pagingInfo).html(`<span>${i}</span>` + ` / ${slick.slideCount}`);
    }
  );

  carousel.slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,
    arrows: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          arrows: false,
        },
      },
    ],
  });
};

export default Slider;
